export default {
  appTitle: 'Web Mobile - Farvagny',
  imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
}
